import { createSelector } from 'reselect';
import { RootState } from 'services/store';

export const selectSlice = (state: RootState) => state.notifications;

export const selectFooterNotification = createSelector(
  selectSlice,
  (slice) => slice.footerNotification,
);
